import axios from "axios";
import { constants } from "../config";

export default class TreatmentService {
  static async get(page, limit, actives, search, listAll) {
    return axios
      .get(constants.api + "/treatments", {
        params: {
          page: page ? page : null,
          actives: actives,
          search: search ? search : null,
          listAll: listAll ? listAll : null,
        },
      })
      .then((response) => {
        if (response.status) {
          return {
            response: response.data,
            ok: true,
          };
        } else {
          return {
            ok: false,
          };
        }
      })
      .catch((error) => {
        return {
          ok: false,
        };
      });
  }
  static async search(search, page, pageSize) {
    return axios
      .post(
        constants.api + "/treatment-search/" + page,
        { search },
        {
          params: {
            limit: pageSize,
          },
        }
      )
      .then((response) => {
        if (response.status) {
          return {
            response: response.data,
            ok: true,
          };
        } else {
          return {
            ok: false,
          };
        }
      })
      .catch((error) => {
        return {
          ok: false,
        };
      });
  }

  static async getActive() {
    return axios
      .get(constants.api + "/treatments-actives")
      .then((response) => {
        if (response.status) {
          return {
            response: response.data,
            ok: true,
          };
        } else {
          return {
            ok: false,
          };
        }
      })
      .catch((error) => {
        return {
          ok: false,
        };
      });
  }

  static async getById(id) {
    return axios
      .get(constants.api + "/treatment/" + id)
      .then((response) => {
        if (response.status) {
          return {
            response: response.data,
            ok: true,
          };
        } else {
          return {
            ok: false,
          };
        }
      })
      .catch((error) => {
        return {
          ok: false,
        };
      });
  }

  static async update(id, data) {
    return axios
      .put(constants.api + "/treatment/" + id, data)
      .then((response) => {
        if (response.status) {
          return {
            response: response.data,
            ok: true,
          };
        } else {
          return {
            ok: false,
          };
        }
      })
      .catch((error) => {
        return {
          ok: false,
        };
      });
  }
  static async create(data) {
    return axios
      .post(constants.api + "/treatment", data)
      .then((response) => {
        if (response.status) {
          return {
            response: response.data,
            ok: true,
          };
        } else {
          return {
            ok: false,
          };
        }
      })
      .catch((error) => {
        return {
          ok: false,
        };
      });
  }
}



// WEBPACK FOOTER //
// ./src/tools/TreatmentsService.js